import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';

export const VALID_REGIONS = ['EUR', 'NAM'] as const;
export type Region = typeof VALID_REGIONS[number];

export const regionValidatorGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const region = route.paramMap.get('region');
  
  if (region && VALID_REGIONS.includes((region ?? '').toUpperCase() as Region)) {
    return true;
  }
  return router.createUrlTree(['/home']);
};